<template>
  <el-row class="login-content">
    <el-col :xs="24" :sm="8" :md="16" :lg="16" class="grid-content left-side">
      <div></div>
    </el-col>
    <el-col :xs="24" :sm="16" :md="8" :lg="8" class="grid-content right-side">
      <div class="login-form">
        <el-alert
          v-if="errorDescription"
          title="Error"
          type="error"
          :description="errorDescription"
          show-icon
        ></el-alert>
        <el-form
          :model="loginForm"
          status-icon
          :rules="rules"
          ref="loginForm"
          label-width="120px"
        >
          <el-form-item label="Email" prop="email">
            <el-input v-model="loginForm.email" placeholder="email" type="email"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input v-model="loginForm.password" placeholder="password" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm()">Submit</el-button>
            <el-button @click="resetForm()">Reset</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import auth from '@/api/auth'
import user from '@/api/user'
export default {
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Password required."));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Email required."));
      } else {
        var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!value.match(mailformat)){
          callback(new Error("Valid email required."));
        }else{
          callback();
        }
        
      }
    };

    return {
      errorDescription: "",
      loginForm: {
        email: "",
        password: "",
        token: ""
      },
      rules: {
        password: [{ trigger: "blur", validator: validatePassword }],
        email: [{ trigger: "blur", validator: validateUsername }]
      }
    };
  },
  methods: {
    checkAuth(){
      if(auth.getToken()){
        this.$router.push('/dashboard')
        return;
      }
      this.getServerToken()
    },
    getServerToken(){
      user.getToken().then(res =>{
        if (res["result"]) {
          this.loginForm.token = res['data']['token']
        }
      })
    },
    submitForm() {
      this.errorDescription = "";
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Login...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.$store
            .dispatch("login", this.loginForm)
            .then(err => {
              if(err){
                console.log(err)
                  this.getServerToken()
                  this.errorDescription = err;
                  return
              }else{
                this.$router.push("/dashboard");
                loading.close();
              }

            })
            .catch(error => {
              this.getServerToken()
              this.errorDescription = error;
              loading.close();
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.loginForm.resetFields();
    },
  },
  created(){
    this.checkAuth()
  }
};
</script>

<style lang="scss">
.login-content {
  .el-row,
  .el-col,
  .left-side,
  .right-side {
    height: 100vh;
    overflow: hidden;
  }

  .left-side {
    background-color: #008080;
    background-image: url("~@/assets/splash.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .right-side {
    background-color: #ffffff;
    padding: 16px;
  }

  .login-form {
    margin-top: 2em;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-icon-loading {
    color: #ffffff !important;
    font-size: 5rem;
  }
  .el-loading-text {
    color: #ffffff !important;
    font-size: 1.6rem !important;
  }

  @media only screen and (max-width: 767px) {
    .left-side {
      display: none;
    }

    .right-side {
      background-image: url("~@/assets/splash.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .login-form{
      background-color: rgba($color: #ffffff, $alpha: 0.5);
      padding: 40px;

    }
  }
}
</style>
